import {CrossVision} from './CrossVision';
import {LogConfiguration} from '../../predefinedstep/message/LogConfiguration';
import {LogSiphonConfiguration} from '../../predefinedstep/message/LogSiphonConfiguration';
import {LogWriterConfiguration} from '../../predefinedstep/message/LogWriterConfiguration';
import {MetricConfiguration} from './MetricConfiguration';
import {Table} from '../../workingtable/message/Table';

export class Configuration {
cron: string;
crossVisions: CrossVision[];
enqueue: boolean | null;
firstFlowCode: string;
inCnxCode: string;
inPath: string[];
incomingField: string;
incomingTable: string;
logConfiguration: LogConfiguration;
metricConfiguration: MetricConfiguration;
outCnxCode: string;
outPath: string[];
tables: Table[];
timeout: number | null;
timeoutLogConfiguration: LogWriterConfiguration;
timeoutLogSiphonConfiguration: LogSiphonConfiguration;
}

